"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
const LabelLocation_1 = require("../../fields/LabelLocation");
// Component rendered in the user interface
// <div class="checkbox-field">
//   <input id="checkbox-id" type="checkbox">
//   <label for="checkbox-id">Checkbox på venstre side af label</label>
// </div>
/**
 * @deprecated use {@link WCAGCheckbox}
 */
class Checkbox extends InputWidget_1.default {
    constructor(arg, labelText) {
        super(document.createElement("input"), true, false);
        if (arg === true || arg === undefined || arg === null) {
            this.checkboxArgs = {
                checked: arg,
                label: labelText || ""
            };
        }
        else {
            this.checkboxArgs = arg;
        }
        this.decorateElement(this._input);
        if (this.checkboxArgs.checked === true) {
            this.setValue(this.checkboxArgs.checked);
        }
    }
    setLabel(label) {
        this.label.textContent = label;
    }
    parseValueFromInput() {
        return this.getInput().checked;
    }
    decorateElement(input) {
        const { label, labelLocation = LabelLocation_1.LabelLocation.RIGHT } = this.checkboxArgs;
        this.element = document.createElement("div");
        const inputId = fmko_ts_common_1.GlobalCounter.next();
        this.label = document.createElement("label");
        this.label.htmlFor = inputId;
        this.label.textContent = label;
        input.id = inputId;
        input.type = "checkbox";
        this.element.classList.add("checkbox-field");
        if (labelLocation === LabelLocation_1.LabelLocation.RIGHT) {
            this.add(input);
            this.add(this.label);
        }
        else {
            this.add(this.label);
            this.add(input);
        }
    }
    setValueOnInput(value, _) {
        this.getInput().checked = value;
    }
}
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map